export default {
  'pages.home': 'ホーム',
  'pages.about': '概要',
  'pages.login_form': 'ログインフォーム',
  'pages.signup_success': 'サインアップ完了',
  'pages.create_business_profile': 'ビジネスプロファイルの作成',
  'pages.complete_profile': 'プロファイルの完了',
  'pages.send_password_successfully': 'パスワードが送信されました',
  'pages.forget_password': 'パスワードをお忘れですか？',
  'pages.ticket_mangment': 'チケットの管理',
};
